import { Context, createContext } from 'react';

export type AuthenticationContextValue = {
  getAccessToken: () => Promise<string>;
  logOut: () => void;
};

const notInitialisedErrorMessage = 'Authentication context has not been initialised yet';

export const AuthenticationContext: Context<AuthenticationContextValue> = createContext<AuthenticationContextValue>({
  getAccessToken: () => Promise.reject(notInitialisedErrorMessage),
  logOut: () => {
    throw new Error(notInitialisedErrorMessage);
  },
});
